var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _path13, _circle2, _path14, _circle3, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 321.7 321.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#709ed6}.st1{fill:#88d2ff}.st8{fill:#ffe6a6}.st9{fill:#ffffe3}.st10{opacity:.4;fill:#bcb49b}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.5 60c-12.2 4.7-25.3 68.1-25.3 68.1 13.1 13.1 35 10.9 35 10.9l16.9-44.9S100.7 55.3 88.5 60z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.5 60c-12.2 4.7-25.3 68.1-25.3 68.1 4.4 4.4 9.8 7.1 15.1 8.7 3-9.6 6.7-21.8 10.2-33.8 4.1-14.2 4.1-31.1 3.3-43.3-1.1-.2-2.2-.1-3.3.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.5 127.6s-13.4-63.4-25.7-68c-12.3-4.6-26.4 34.2-26.4 34.2l10.5 41.9c.1 0 28.6 5 41.6-8.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.5 70.9c.7 19.9 3.4 48 12.2 65.8 9.3 0 21.5-1.7 28.8-9.1 0 0-13.4-63.4-25.7-68-5.1-2-10.7 3.9-15.3 11.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3 59.7c2.6-1 13.3-5.1 51.9-19.8h41.4c.1.1 49.6 18.9 51.1 20 0 .1-17.2 11.9-18.4 70.8-.9 39.8 4 131.8 4 131.9 0 0-38.7 27.5-116.7 2.6l2.6-141.1c-1.5-11.5-8.4-56-16.6-64.2l.7-.2z",
    fill: "#a6ddff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M219.1 262.6s-38.7 27.5-116.7 2.6l2.6-141.1s-7.4-55-16.6-64.2l4-1.5c7 15.3 22.5 50.5 22.5 63.3 0 16.5 2.4 108 5.2 120.6 3 12.5 64.3 29.8 99 20.3z",
    opacity: 0.58,
    fill: "#5f89c6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160.7 112.2c-3.9 0-7.1-3.2-7.1-7.1v-51h14.2v51c-.1 3.9-3.2 7.1-7.1 7.1z",
    fill: "#c3e4fa"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M167.7 54.1c.2 4.1 2 50.8 0 54.3-1.3 2.4-4.5 3.9-7.1 3.7 2.9-.1 5.8-2.1 6.6-5.7.3-1.5-.5-28.3.5-52.3z",
    fill: "#5f83c6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M161 54.6c-19.6 2.2-26.1-21-22.9-22.3 0 0 34.6 1.4 42.7.2.9-.1 1.9.1 2.6.6 1.3 4.7-6.7 19.7-22.4 21.5z",
    fill: "#505d79"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M177.8 45.8c4.3-4.8 6.3-10.2 5.7-12.7-.8-.5-1.7-.7-2.6-.6-8.2 1.1-42.7-.2-42.7-.2-1.7.7-.7 7.5 3.5 13.5 10 .3 29.6.8 36.1 0z",
    fill: "#dbc083"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M161 54.6l-15.7 21.6s-19.6-23.4-16.7-31.5c2.9-8.1 8-12.4 9.5-12.4-3.2 1.3 3.3 24.4 22.9 22.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M175.1 74L161 54.6c16.4-1.8 23.5-17.4 22.6-21.4 2 1.4 5.8 4.5 9 10.3 4.5 8.2-17.5 30.5-17.5 30.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 160.3,
    cy: 69.3,
    r: 2.9
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M160.3 66.4c-.2 0-.4 0-.5.1 1.4.3 2.4 1.4 2.4 2.9 0 1.4-1 2.6-2.4 2.9.2 0 .4.1.5.1 1.6 0 2.9-1.3 2.9-2.9.1-1.8-1.2-3.1-2.9-3.1z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 160.3,
    cy: 83.2,
    r: 2.9
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M160.3 80.2c-.2 0-.4 0-.5.1 1.4.3 2.4 1.4 2.4 2.9 0 1.4-1 2.6-2.4 2.9.2 0 .4.1.5.1 1.6 0 2.9-1.3 2.9-2.9.1-1.8-1.2-3.1-2.9-3.1z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 160.3,
    cy: 98.9,
    r: 2.9
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M160.3 96c-.2 0-.4 0-.5.1 1.4.3 2.4 1.4 2.4 2.9 0 1.4-1 2.6-2.4 2.9.2 0 .4.1.5.1 1.6 0 2.9-1.3 2.9-2.9.1-1.8-1.2-3.1-2.9-3.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M205.5 268.8c-31.1 11-70.4 5.8-102.1-4.3.5-32.6 1.4-86.1 1.3-121.8-1.4 33.4-2.6 89.8-3.3 123.3 21.4 6.1 32.1 8.8 52.4 10.2 2.1 0 41.3 2.6 65.4-13.5-4.3 2.6-9 4.5-13.7 6.1z",
    fill: "#5c7a93"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M145.3 75.3c-4.6-5.7-18.6-23.5-16.7-30.6-2.9 7.8 12.1 26.5 16.7 32.3 4.7-6.6 10.9-15.2 15.6-22.5-5 6.4-11.2 14.8-15.6 20.8zm47.3-31.8c3.3 7.1-11.9 23.9-17.4 29.7-3.7-5-10.3-13.8-14.2-18.6 4.5 6.8 11.6 16.7 14.1 20.2 1.5-1.8 22.5-22.9 17.5-31.3z",
    fill: "#c46f74"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M207.7 64.4s-29.2 82.3-58.8 85c-29.7 2.7-7.3 100 28.3 94.3 35.6-5.6 30.5-179.3 30.5-179.3z",
    opacity: 0.46,
    fill: "#c0eaff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.26472588a5fc9a200f10a27e53e598ee.svg";
export { ForwardRef as ReactComponent };